export const Panel = ({ title, code, right, className = '', children, testId, delay = 0 }) => (
  <section data-testid={testId} className={`panel p-5 ${className}`} style={{ animationDelay: `${delay}ms` }}>
    <header className="mb-4 flex items-start justify-between gap-3">
      <div>
        {code && <div className="label-eyebrow mb-1 text-[var(--dim)]">{code}</div>}
        <h2 className="font-display text-base font-bold uppercase tracking-[0.14em] text-[var(--ink)] md:text-lg">{title}</h2>
      </div>
      {right}
    </header>
    {children}
  </section>
);
